module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_komsco.3fc2ebdee1a896f2fd6a38257fc1df44.png";